import React from 'react';
import clsx from 'clsx';

const Card = ({ 
  children, 
  className = '', 
  hover = false, 
  glow = false, 
  glass = false,
  onClick,
  ...props 
}) => {
  const cardClasses = clsx(
    'rounded-xl transition-all duration-300',
    {
      'glass border border-white/10': glass,
      'neomorphism': !glass,
      'hover-lift cursor-pointer': hover,
      'glow-blue': glow,
      'card-hover': hover,
    },
    className
  );

  return (
    <div 
      className={cardClasses} 
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
